import { render, staticRenderFns } from "./TripTags.vue?vue&type=template&id=67e7c6e2&scoped=true&"
import script from "./TripTags.vue?vue&type=script&lang=js&"
export * from "./TripTags.vue?vue&type=script&lang=js&"
import style0 from "./TripTags.vue?vue&type=style&index=0&id=67e7c6e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e7c6e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e7c6e2')) {
      api.createRecord('67e7c6e2', component.options)
    } else {
      api.reload('67e7c6e2', component.options)
    }
    module.hot.accept("./TripTags.vue?vue&type=template&id=67e7c6e2&scoped=true&", function () {
      api.rerender('67e7c6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/trips/TripTags.vue"
export default component.exports